export default __webpack_public_path__ + "static/media/405.13716547.jpg";